import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "steps-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "steps" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "icon-block" }
const _hoisted_6 = { class: "step-icon curstep" }
const _hoisted_7 = { class: "text ellipsis" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createBlock(_component_Collapse, {
    open: $options.open,
    horizontal: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ScrollBar, { class: "steps-scrollbar" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Icon, {
                class: "icon pointer",
                icon: "x-close-thin",
                height: "4.8rem",
                width: "4.8rem",
                "stroke-width": "2",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
              }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, " Onboarding Progress ", -1 /* HOISTED */))
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.steps, (step, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass(["step-item", {passed: idx < $data.current_step, current: idx === $data.current_step}])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Icon, {
                        class: "step-icon passed",
                        icon: "custom/circle-check",
                        width: "1.6rem",
                        height: "1.6rem"
                      }),
                      _createVNode(_component_Icon, {
                        class: "step-icon not-passed",
                        icon: "custom/circle-dot-gray",
                        width: "1.6rem",
                        height: "1.6rem"
                      }),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "circle" }, null, -1 /* HOISTED */)),
                        _createVNode(_component_Icon, {
                          icon: "custom/circle-dot-green",
                          class: "icon",
                          width: "1.6rem",
                          height: "1.6rem"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(step.title), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(step.description), 1 /* TEXT */)
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["open"]))
}